import React from 'react';

// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766
import styled from '@emotion/styled';
import { HelperMessage } from '@atlaskit/form';
export const QuestionHelperMsg = ({
  description
}) => {
  return !!description ? /*#__PURE__*/React.createElement(HelperMessageWrapper, null, /*#__PURE__*/React.createElement(HelperMessage, null, /*#__PURE__*/React.createElement("span", {
    "data-testid": "description"
  }, description))) : null;
};

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const HelperMessageWrapper = styled.div({
  // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
  '> div': {
    fontSize: '11px',
    marginBottom: "var(--ds-space-050, 4px)"
  }
});